export class Footer{

    public static init() {
		document.addEventListener('DOMContentLoaded', Footer.onDocumentLoaded, false);
	}

    private static onDocumentLoaded() {
        const footer = document.getElementById("footer");

        if(footer == null){
            return;
        }

        footer.getElementsByClassName("_footerScrollTop")[0].addEventListener("click", Footer.onScrollTopClick);
	}

    private static onScrollTopClick(){
        window.scrollTo(0, 0,);
    }
}
